import { InfoCircleOutlined } from '@ant-design/icons/lib/icons';
import { Divider, Modal, Select, Typography } from 'antd';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

const formatDictionary = dictionary => {
  return dictionary.map(item => ({
    value: item.id,
    label: item.title,
    description: item.description,
  }));
};

const DevotionOfferingSelector = ({ fieldName, onChange, disabled, fieldValue, dictionary }) => {
  const [isMassesInfoModalOpen, setMassesInfoModalOpen] = useState(false);
  const showMassesInfoModal = () => {
    setMassesInfoModalOpen(true);
  };
  const hideMassesInfoModal = () => {
    setMassesInfoModalOpen(false);
  };

  const devotionOfferingTypes = formatDictionary(dictionary);

  const selectedOptionMetadata = devotionOfferingTypes?.find(
    offeringType => offeringType.value === fieldValue,
  );

  return (
    <>
      <Typography.Title level={4}>
        Rodzaj intencji&nbsp;&nbsp;&nbsp;
        <InfoCircleOutlined onClick={showMassesInfoModal} />
      </Typography.Title>

      <Select
        disabled={disabled}
        name={fieldName}
        variant="outlined"
        onChange={newType => {
          if (onChange) {
            onChange(newType);
          }
        }}
        value={fieldValue}
        style={{ width: '300px' }}
      >
        {devotionOfferingTypes.map(object => {
          return (
            <Select.Option key={object.value} value={object.value}>
              {object.label}
            </Select.Option>
          );
        })}
      </Select>

      {selectedOptionMetadata && (
        <>
          <Divider />
          <div>{selectedOptionMetadata.description}</div>
        </>
      )}

      {devotionOfferingTypes && (
        <Modal
          title="Jaki rodzaj intencji wybrać"
          open={isMassesInfoModalOpen}
          onOk={hideMassesInfoModal}
          onCancel={hideMassesInfoModal}
          okText="Zamknij"
          footer={<></>}
        >
          <>
            {devotionOfferingTypes.map(offeringType => {
              return (
                <React.Fragment key={offeringType.value}>
                  <b>{offeringType.label}</b> - {offeringType.description}
                  <br />
                </React.Fragment>
              );
            })}
          </>
        </Modal>
      )}
    </>
  );
};

DevotionOfferingSelector.propTypes = {
  disabled: PropTypes.bool,
  fieldName: PropTypes.string.isRequired,
  fieldValue: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  dictionary: PropTypes.array,
};

export default DevotionOfferingSelector;
